import React, { cloneElement } from 'react';
import { Button, Modal, FormControl, ControlLabel, Alert, FormGroup, Checkbox } from "react-bootstrap";
import moment from 'moment';
import immutable from "immutable";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import util from "./../../lib/util.js";

export default class PtoListByTimecard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            selectedIds: [],
            errors: []
        }

        this.loadList = this.loadList.bind(this);
        this.onToggleSelection = this.onToggleSelection.bind(this);
        this.save = this.save.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount() {
        this.loadList();
    }

    loadList() {
        ajax.api()
            .get(`get-pto-lines-by-timecard/${this.props.timecardId}`)
            .then(res => {
                const clone = immutable.fromJS(this.state).toJS();
                clone.list = res.data;

                if (this.props.filterStatusCode && this.props.filterStatusCode !== "")
                    clone.list = clone.list.filter(o => o.statusCode == this.props.filterStatusCode);

                clone.selectedIds = clone.list.map(o => o.ptoId);

                this.setState(clone);

                if (this.props.onLoad)
                    this.props.onLoad(res.data);
            }).catch(function (err) {
                let data = err.response? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onToggleSelection(evt) {
        const clone = immutable.fromJS(this.state).toJS();
        const ptoId = parseInt(evt.target.value);

        if (evt.target.checked)
            clone.selectedIds.push(ptoId);
        else
            clone.selectedIds = clone.selectedIds.filter(o => o !== ptoId);

        this.setState(clone);
    }

    close() {
        if (this.props.onClosed) 
            this.props.onClosed();
    }

    save(action) {
        const self = this;
        const enableSelection = this.props.enableSelection
        const ptoIds = [...new Set(this.state.selectedIds)]; // return distinct Ids

        if (ptoIds.length == 0)
            return;

        const msg = (action == "approve")? "Approved!" : "Saved successfully.";
        context.message({
            show: true,
            type: "loading",
            message: "Saving. Please wait..."
        });

        let errors = []
        let apiCalls = [];
        for (let i=0; i < ptoIds.length; i++) {
            apiCalls.push(
                ajax.api()
                    .post('update-pto', {
                            ptoId: ptoIds[i],
                            supervisorNotes: `Mass ${action} from timecard #${self.props.timecardId}`,
                            action: action,
                            actionDates: []
                        })
                    .catch(function(err) {
                            let data = err.response? err.response.data : err;
                            errors.push(data.exceptionMessage || data.message);
                        })
                );
        }

        // allSettled -> continue executing all calls even if one failed
        Promise.allSettled(apiCalls)
            .then(res => {
                if (errors.length > 0) {
                    context.message({ show: false });
                    self.setState({ errors: errors });
                }
                else {
                    context.message({
                        show: true,
                        type: "info",
                        message: msg,
                        buttons: "close"
                    }, () => {
                        if (self.props.onSaved) self.props.onSaved();
                    });
                }
            });
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const isMobile = this.isIos() || this.isAndroid();
        const clsMain = isMobile? "ap-pto-detail mobile" : "ap-pto-detail";
        const enableSelection = this.props.enableSelection || false;

        let items = this.state.list;
        let selectedIds = this.state.selectedIds;
        let errors = this.state.errors;
        let gridContent = [];

        if (items.length == 0) {
            gridContent.push(
                <div className="row ap-pto-list-item" key="pto_empty">
                    <div className="col-xs-12 col-md-12">
                        No records found.
                    </div>
                </div>);
        }
        else {
            //items = items.sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
            for (let i=0; i<items.length; i++) {

                gridContent.push(
                    <div className="row" key={items[i].ptoLineId}>
                        <div className="col-xs-12 col-md-12">
                            <div>
                                <div className={enableSelection? "col-xs-1 col-md-1 ap-pto-list-unapproved-checkbox" : "ap-hidden"}>
                                    <input type="checkbox" value={items[i].ptoId} checked={selectedIds.indexOf(items[i].ptoId) > -1} onChange={this.onToggleSelection} />
                                </div>
                                <div className={`${enableSelection? "col-xs-10 col-md-11" : "col-xs-12 col-md-12"} ap-pto-list-unapproved`}>
                                    <div className="row">
                                        <div className="col-xs-3 col-md-3">
                                            {moment(items[i].actionDate).format("MM/DD/YYYY")}
                                        </div>
                                        <div className="col-xs-4 col-md-3 ap-unwrap-content">
                                            {util.toHrmString(items[i].unit)}
                                        </div>
                                        <div className="col-xs-5 col-md-6 text">
                                            {items[i].description}
                                        </div>
                                        <div className="col-xs-12 col-md-12 text ap-pt-1">
                                            Reason: {items[i].reasonDesc}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                );
            }
        }

        return (
            <div className={clsMain}>
                {gridContent}
                <div className="row">
                    <div className="col-xs-12 col-md-12 button-panel">
                        <Button onClick={() => this.save("approve")}>Approve</Button>
                        <Button onClick={this.close}>Cancel</Button>
                    </div>
                </div>
                <div className={errors.length > 0? "row" : "ap-hidden"}> 
                    <div className="col-xs-12 col-md-12 error-panel">
                        <Alert bsStyle="danger">
                            <ul>{ errors.map((e, idx) => <li key={idx}>{e}</li>) } </ul>
                        </Alert>
                    </div>
                </div>
            </div>
        );
    }
}